import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../userMaster/userMaster.scss";
import "react-datepicker/dist/react-datepicker.css";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import UserDetails from "../../components/userMaster/UserDetails";
import useForm from "./useForm";
import FetchData from "../../providers/dataProvider";

const AddNewUser = () => {
  const {
    formValues,
    formErrors,
    handleFormSubmit,
    handleFormChange,
    show,
    setShow,
    createMsg,
    clearFormValues,
    handleUserTypeChange,
    handleCostingPermission,
    handleCompanyChange,
    companyName,
    setCompanyName,
    handleDepartmentChange,
    departmentName,
    handleDesignationChange,
    designationName,
    handleUserRoleChange,
    UserRoleName,
    UserReportingName,
    handleUserReportingChange,
    setDesignationName,
    setDepartmentName,
    setUserRoleName,
    setUserReportingName,
    setUserType,
    errorShow,
    ErrorDoneClick,
    handlePermissionType,
    checkedPermissions,
    setCheckedPermissions,
    userTypedrp,
    userType,
    SuccessDoneClick,
    handleToggleChange,
    isChecked,
    setFormValues,
    isSubmit,
    isSubmiting,
    setFormErrors,
    loading
  } = useForm();

  const { data: Department } = FetchData("department");
  const { data: Company } = FetchData("company");
  const { data: Designation } = FetchData("designation");
  const { data: userRole } = FetchData("userrole");
  const { data: userReport } = FetchData("userprofile");
  const { data: Distributor } = FetchData("distributor");

  const location = useLocation();

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: formValues?.id ? "Edit User" : "Add User",
        backTarget: { pathname: "/user-master" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [formValues?.id, location.pathname]);

  return (
    <div className="container-fluid add-new-user-sec">
      <UserDetails
        formValues={formValues}
        formErrors={formErrors}
        handleFormSubmit={handleFormSubmit}
        handleFormChange={handleFormChange}
        handleUserTypeChange={handleUserTypeChange}
        handleCostingPermission={handleCostingPermission}
        handleCompanyChange={handleCompanyChange}
        companyName={companyName}
        setCompanyName={setCompanyName}
        Department={Department}
        Company={Company}
        handleDepartmentChange={handleDepartmentChange}
        departmentName={departmentName}
        Designation={Designation}
        handleDesignationChange={handleDesignationChange}
        designationName={designationName}
        userRole={userRole}
        handleUserRoleChange={handleUserRoleChange}
        UserRoleName={UserRoleName}
        userReport={userReport}
        UserReportingName={UserReportingName}
        handleUserReportingChange={handleUserReportingChange}
        setDesignationName={setDesignationName}
        setDepartmentName={setDepartmentName}
        setUserRoleName={setUserRoleName}
        setUserReportingName={setUserReportingName}
        setUserType={setUserType}
        handlePermissionType={handlePermissionType}
        checkedPermissions={checkedPermissions}
        setCheckedPermissions={setCheckedPermissions}
        userTypedrp={userTypedrp}
        userType={userType}
        clearFormValues={clearFormValues}
        Distributor={Distributor}
        handleToggleChange={handleToggleChange}
        isChecked={isChecked}
        setFormValues={setFormValues}
        isSubmit={isSubmit}
        isSubmiting={isSubmiting}
        setFormErrors={setFormErrors}
        loading={loading}
      />

      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />

      {/* <!-- saveSuccessModal start--> */}
      <SaveSuccessModel
        show={show}
        createMsg={createMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />
    </div>
  );
};

export default AddNewUser;